import { jsx } from "panel";
import { ModalEl, ModalType } from "common/components/modal";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
export function template() {
  const {
    open,
    responseText,
    score,
    submittedScore,
    surveyId
  } = this.state;
  return /* @__PURE__ */ jsx(ModalEl, { sel: ".nps-survey-root", class: {
    "nps-survey-score-screen": !submittedScore,
    "nps-survey-text-screen": submittedScore
  }, attrs: {
    closeable: true,
    "modal-type": ModalType.Popup,
    "not-fullscreen": true,
    open
  }, on: {
    change: this.helpers.handleModalChange
  }, "data-sentry-element": "ModalEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".nps-survey-content", class: {
    "nps-survey-score-screen": !submittedScore,
    "nps-survey-text-screen": submittedScore
  } }, !submittedScore ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".nps-survey-header" }, "How likely are you to recommend Mixpanel to a friend or colleague?"), /* @__PURE__ */ jsx("div", { sel: ".nps-survey-scores" }, this.helpers.getScores().map((option) => /* @__PURE__ */ jsx("div", { sel: ".nps-survey-score-button", on: {
    click: () => this.helpers.handleClickScore(option)
  } }, option))), /* @__PURE__ */ jsx("div", { sel: ".nps-survey-likeliness" }, /* @__PURE__ */ jsx("span", null, "Not at all likely"), /* @__PURE__ */ jsx("span", null, "Extremely likely"))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".nps-survey-header" }, "Thank you! Your feedback has been sent."), /* @__PURE__ */ jsx("div", { sel: ".nps-survey-question" }, /* @__PURE__ */ jsx("span", { sel: ".nps-survey-text" }, "We read every single response. Why did you rate Mixpanel a ", score, "?")), /* @__PURE__ */ jsx("div", { sel: ".nps-survey-response-text-container" }, /* @__PURE__ */ jsx(InputEl, { sel: ".nps-survey-response-text", attrs: {
    type: "textarea",
    autofocus: true,
    value: responseText
  }, on: {
    input: this.helpers.handleTextInput
  } })), /* @__PURE__ */ jsx("div", { sel: ".nps-survey-button-container" }, /* @__PURE__ */ jsx(ButtonEl, { sel: ".nps-survey-dismiss-button", on: {
    click: this.helpers.handleClickDismiss
  } }, "Dismiss"), /* @__PURE__ */ jsx(ButtonEl, { sel: ".nps-survey-submit-button", attrs: {
    theme: ButtonTheme.Primary,
    disabled: !Number.isInteger(surveyId)
  }, on: {
    click: this.helpers.handleClickSubmit
  } }, "Submit")))));
}
